// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.section[data-v-cd2bce62]{position:relative}@media (min-width:768px) and (max-width:1023px){.image[data-v-cd2bce62] img{right:0;left:auto;width:45%}}.border[data-v-cd2bce62]{position:absolute;bottom:6rem;width:33rem;margin-top:auto;height:1px;background:var(--primary)}@media (max-width:767px){.border[data-v-cd2bce62]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
